import styled from "styled-components";

export const CurrencyAmountInputValueBox = styled.input.attrs({
    type:"number",
    placeholder: "0",
    })`
        border: 0;
        padding: 5px 15px;
        font-size: 1.5rem;
        background: none;
        color: ${({theme}) => theme.colors.textLight};
        width: 100%;
        &:focus {
            outline: none;
        }
        ::-webkit-inner-spin-button{
            -webkit-appearance: none; 
            margin: 0; 
        }
        ::-webkit-outer-spin-button{
            -webkit-appearance: none; 
            margin: 0; 
        }  
`;